const isFlaggingEnabled = process.env.APP_MODE !== 'development';

export default {
  overview: {
    path: '/overview',
    isShown: true,
  },
  timeline: {
    path: '/timeline',
    isShown: true,
  },
  questionnaire: {
    path: '/questionnaire',
    isShown: true,
  },
  interviews: {
    path: '/interviews',
    isShown: true,
    confirm: {
      isShown: false,
    },
  },
  draft: {
    path: '/project',
    isShown: true,
  },
  photos: {
    path: '/photos',
    isShown: true,
  },
  'cover-creator': {
    path: '/cover-creator',
    isShown: true,
  },
  'final-proof': {
    path: '/final-proof',
    isShown: true,
  },
  upgrades: {
    path: '/upgrades',
    isShown: true,
  },
  account: {
    path: '/account',
    isDisabled: isFlaggingEnabled,
    isShown: !isFlaggingEnabled,
  },
  outline: {
    isShown: true,
  },
  'style-samples': {
    path: 'style-samples',
    isShown: true,
  },
  'book-sample': {
    path: '/book-sample',
    isShown: true,
  },
  isShownAIChatbot: false,
  isProofreadButton: false,
  isShownCustomUpgradeRequests: true,
};
